import { render } from "./SingleBlogItem.vue?vue&type=template&id=acd14e90"
import script from "./SingleBlogItem.vue?vue&type=script&lang=js"
export * from "./SingleBlogItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__